/**
 * Utility functions for localStorage and sessionStorage access
 */

import { environment } from '../../environments/environment';
import { LOCAL_STORAGE_KEYS } from '../constants/storage-keys';

/**
 * Gets the current language from localStorage with fallback to default
 * @returns The language code (e.g., 'en', 'es', 'ar')
 */
export function getLanguageWithFallback(): string {
  try {
    return (
      localStorage.getItem(LOCAL_STORAGE_KEYS.LANGUAGE) ??
      environment.DEFAULT_LANGUAGE ??
      'en'
    );
  } catch (e) {
    return environment.DEFAULT_LANGUAGE ?? 'en';
  }
}
